
<div class="geolocation-prompt-panel">
  <div class="geolocation-prompt-panel-component hidden">
    <div class="component-background" @click="close" />
    <slide-y-down-transition :duration="1000">
      <div v-show="show" class="wrapper" :class="$store.state.theme">
        <span class="close">
          <i class="fa fa-times-circle fa-lg" @click="close" />
        </span>
        <p style="margin-bottom:10px">
          <img :src="$store.state.geolocationPic" style="height:150px; width:150px" />
        </p>
        <p class="is-size-5">{{ $t("gps.geolocation-request") }}</p>
        <br />
        <span class="button is-warning is-rounded" @click="close">{{ this.$t("next") }}</span>
      </div>
    </slide-y-down-transition>
  </div>
</div>
